import { render, staticRenderFns } from "./TempConfigSubMajorList.vue?vue&type=template&id=25007ed2&scoped=true"
import script from "./TempConfigSubMajorList.vue?vue&type=script&lang=js"
export * from "./TempConfigSubMajorList.vue?vue&type=script&lang=js"
import style0 from "./TempConfigSubMajorList.vue?vue&type=style&index=0&id=25007ed2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25007ed2",
  null
  
)

export default component.exports